import { createSelector } from "reselect";
import { getCurrentUser } from "./userSelectors";
import { statusString } from "../utils/statusString";

export const canAccessTeacherMocks = createSelector(getCurrentUser, (user) => {
  if (!user) return statusString.loading;

  return ["admin", "super"].includes(user.role)
    ? statusString.allow
    : statusString.deny;
});
